import { render, staticRenderFns } from "./CaptionsView.vue?vue&type=template&id=18175ec2&scoped=true"
import script from "./CaptionsView.vue?vue&type=script&lang=js"
export * from "./CaptionsView.vue?vue&type=script&lang=js"
import style0 from "./CaptionsView.vue?vue&type=style&index=0&id=18175ec2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18175ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18175ec2')) {
      api.createRecord('18175ec2', component.options)
    } else {
      api.reload('18175ec2', component.options)
    }
    module.hot.accept("./CaptionsView.vue?vue&type=template&id=18175ec2&scoped=true", function () {
      api.rerender('18175ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CaptionsView.vue"
export default component.exports